<template>
  <div
    id="cc-transacions"
    class="mt-3"
    v-if="creditCardData">
    <!-- Page Header -->
    <div class="container-fluid">
      <div class="row mb-3">
        <div class="col">
          <div class="d-flex flex-column flex-sm-row align-items-center">
            <h3 class="flex-fill mb-0 mr-3 text-center text-sm-left">
              Recent Transactions
            </h3>

            <div class="flex-fill text-center">
              <div
                :class="{
                  'text-success font-weight-bold': creditCardData.balance.available > 0,
                  'text-danger font-weight-bold': creditCardData.balance.available < 0,
                }">
                Available: {{creditCardData.balance.available | currency}}
              </div>

              <div>
                Pending: {{creditCardData.balance.pending | currency}}
              </div>
            </div>

            <div class="flex-fill d-flex align-items-center justify-content-end">
              <b-button
                type="button"
                variant="link"
                :disabled="generatingReport"
                @click="downloadPayoutReport">
                Download Payout Report CSV
              </b-button>

              <font-awesome-icon
                :icon="['fab', 'cc-stripe']"
                size="3x">
              </font-awesome-icon>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- / Page Header -->

    <!-- Transactions Table -->
    <b-table
      striped
      hover
      small
      show-empty
      sort-desc
      sort-by="created"
      :items="creditCardData.log"
      :fields="fields"
      empty-text="No Transactions to show.">
      <!-- Created -->
      <template
        slot="created"
        slot-scope="{ item }">
        {{ item.created_display }}
      </template>
      <!-- Created -->

      <!-- Available -->
      <template
        slot="available_on"
        slot-scope="{ item }">
        {{ item.available_on_display }}
      </template>
      <!-- Available -->

      <!-- Type -->
      <template
        slot="type"
        slot-scope="{ item }">
        <div class="d-flex align-items-center text-capitalize">
          {{ item.type.replace(/_/g, ' ') }}
          <b-button
            class="py-0"
            size="sm"
            v-if="item.type === 'payment'"
            variant="link"
            @click="goToOrderDetails(item)">
            View Order Details
          </b-button>
        </div>
      </template>
      <!-- Type -->
    </b-table>
    <!-- / Transactions Table -->
  </div>
</template>

<script>
import moment from 'moment';
import DataSvc from '../services/data';
import AppMixin from '../services/app-mixin';
import Formatters from '../services/formatters';
import EventBus from '../services/event-bus';

export default {
  name: 'cc-transacions',
  mixins: [
    AppMixin,
  ],
  data() {
    return {
      generatingReport: false,
      creditCardData: false,
      fields: [
        {
          key: 'created',
          label: 'Created',
          sortable: true,
        },
        {
          key: 'available_on',
          label: 'Available',
          sortable: true,
        },
        {
          key: 'status',
          tdClass: 'text-capitalize',
          sortable: true,
        },
        {
          key: 'type',
          sortable: true,
        },
        {
          key: 'amount',
          class: 'text-right',
          formatter: Formatters.currency,
          sortable: true,
        },
        {
          key: 'fee',
          label: 'KJK Fee',
          class: 'text-right',
          formatter: Formatters.currency,
          sortable: true,
        },
        {
          key: 'net',
          class: 'text-right',
          formatter: Formatters.currency,
          sortable: true,
        },
      ],
    };
  },
  methods: {
    getCreditCardData() {
      this.showGlobalLoader('Loading transactions...');
      return DataSvc.getCreditCardTransactions(this.loggedInUser.actingOrg.id)
        .then((creditCardData) => {
          this.creditCardData = creditCardData;
        })
        .finally(this.hideGlobalLoader);
    },
    goToOrderDetails(transaction) {
      this.showGlobalLoader('Loading order details...');

      DataSvc.getRegistrationSessionFromTransaction(
        this.loggedInUser.actingOrg.id,
        transaction.source_id,
      ).then((registrationSession) => {
        this.goToOrder(registrationSession.uuid);
      }).finally(this.hideGlobalLoader);
    },
    downloadPayoutReport() {
      this.showGlobalLoader('Generating report...');
      this.generatingReport = true;

      return DataSvc.downloadPayoutReport(this.loggedInUser.actingOrg.id)
        .then((report) => {
          const url = window.URL.createObjectURL(new Blob([report]));
          const link = document.createElement('a');
          const org = this.loggedInUser.actingOrg.name.replace(/ /g, '_').toLowerCase();
          const timestamp = moment().format('M-D-YY_h-mm_a');
          const filename = `payout_report_${org}_${timestamp}.csv`;

          link.href = url;
          link.setAttribute('download', filename);
          document.body.appendChild(link);
          link.click();
          link.remove();
        }).finally(() => {
          this.generatingReport = false;
          this.hideGlobalLoader();
        });
    },
  },
  created() {
    this.showGlobalLoader('Loading transactions...');

    const initTransactions = () => {
      EventBus.$on('acting-org-changed', this.getCreditCardData);
      return this.getCreditCardData();
    };

    this.initPromise.then(initTransactions).finally(this.hideGlobalLoader);
  },
  destroyed() {
    EventBus.$off('acting-org-changed', this.getCreditCardData);
  },
};
</script>

<style lang="scss"></style>
